module.exports = __webpack_public_path__ + "img/image95.8f362915.jpg";